var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",class:_vm.wrapClass},[_c('router-view',{attrs:{"name":"header"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"content"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"footer"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-992ebf8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/layouts/DefaultLayout.vue
// module id = i1jV
// module chunks = 19